/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { CustomFilter } from 'app/ComponentLibrary/Filter';
import {
  getCitiesAndZipsByStates
} from 'app/services/SharedServices/SharedServices';
import {
  OrderMatchFlterName,
  OrderMatchSearchFilters, fetchFilterSpecs,
  findSubSpecialities,
  findspecialities,
  getDefaultAppliedFilters,
  getDisciplineAndSpecialty,
  getOrderPreferencePreFilters,
  getSkillSets,
  manualFilterApply
} from './OrderMatchFilterUtils';
import { SearchType } from 'app/models/GlobalSearch/GlobalSearch';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { getCandidateOrderMatchActions } from '../store/candidateOrderMatch.redux';
import {
  selectFilters,
  selectGridFiltersExpanded,
} from 'app/components/Common/Grid/GridStateManagement/GridState.selectors';
import { useDispatch, useSelector } from 'react-redux';
import { IStateCityZip } from 'app/models/Candidate/IStateCityZip';
import { getAllCitiesAndZips } from 'app/components/GlobalSearch/Candidate/FilterUtils';
import { Collapse, Grid, Skeleton } from '@mui/material';
import { gridStateActions } from '@AMIEWEB/Common/Grid/GridStateManagement/GridState.redux';
import { SearchPageIcons } from 'app/ComponentLibrary/Filter/SearchPageIcons';
import { makeStyles } from 'tss-react/mui';
import { candidateDetailsSelection } from '@AMIEWEB/Candidate/CandidateProfile/Profile/CandidateDetails.selector';
import { selectCandidateLookUpPrefilter, selectCandidateOrderMatchId } from '../store/candidateOrderMatch.selector';
import { selectJobPreferencesData, selectPreferenceId } from '../../JobPreferencesTab/store/JobPreferences.selectors';
import { getMatchingShiftOptions, getMatchingStateOptions, processJobPreferencesData } from './OrderDrawerHelper';
import { RootState } from 'types';
import { useParams } from 'react-router-dom';
import { usePromiseTracker } from 'react-promise-tracker';
import { jobPreferncesActions } from '../../JobPreferencesTab/store/JobPreferences.redux';
import { selectUserPreference } from 'oidc/UserDevicePreference/userPreference.selectors';

const useStyles = makeStyles()({
  fillterCollapse: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '3px',
  },
  collapse: {
    paddingTop: '4px',
  },
});
const OrderMatchesFilters = props => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { setValue } = useFormContext();
  const dispatch = useDispatch();
  const { promiseInProgress: candidateDetailsLoading } = usePromiseTracker({
    area: 'get-candidate-details-wrapper-promise',
    delay: 0,
  });
  const gridStateFilters = useSelector(selectFilters);
  const allCitiesandZipsData = useRef<IStateCityZip[]>();
  const candidateDetails = useSelector(candidateDetailsSelection);
  let jobPreferenceIdFromGrid = useSelector(selectCandidateOrderMatchId);
  const orderPreferenceId = useSelector(selectPreferenceId);
  const { jobPreferencesData } = useSelector(selectJobPreferencesData);
  const orderPreferenceLookups = useSelector(selectCandidateLookUpPrefilter);
  let orderPrefId = jobPreferenceIdFromGrid ?? orderPreferenceId;
  const [orderPreferenceResult, setOrderPreferenceResult] = useState<any>(
    processJobPreferencesData(jobPreferencesData, orderPrefId),
  );
  const matchingShiftOpts = getMatchingShiftOptions(
    orderPreferenceResult?.shiftOpts,
    orderPreferenceLookups?.shiftOpts,
  );
  const matchingStateOpts = getMatchingStateOptions(
    orderPreferenceResult?.state || [],
    orderPreferenceLookups?.statesOpts,
  );
  const [skillset, setSkillset] = useState();
  const [prefSkillset, setPrefSkillset] = useState(null);
  const { travelerId: candidateId, brandId: candidateBrandId } = useParams<{ travelerId: string; brandId: string }>();
  const [filterKey] = React.useState<any>(`candidate-${candidateId}`);
  const userPreference = useSelector(selectUserPreference);
  const filtersExpanded = useSelector(selectGridFiltersExpanded);
  const savedUserFilterPreferences = useSelector((state: RootState) => {
    return state.userPreferenceData.userGridPreferences.find(item => item.id === filterKey);
  });
  const gridSpecs = useRef(
    new OrderMatchSearchFilters(
      {
        divisionOpts: [],
        businessRelationshipsOpts: [],
        facilityStatusesOpts: [],
        orderTypesOpts: [],
        disciplineOpts: [],
        specialityOpts: [],
        subSpecialtiesOpts: [],
        statesOpts: [],
        compactStatesOpts: [],
        cityptions: [],
        zipOptions: [],
        facilityOpts: [],
        mspClientOpts: [],
        orderReasonOpts: [],
        accountManagerOpts: [],
        orderPrioritiesOpts: [],
        shiftOpts: [],
        orderIds: [],
        regionOpts: [],
        staffingVendorOpts: [],
        techVendorOpts: [],
      },
      gridStateFilters,
    ),
  );
  const [allSpecialities, setAllSpecialities] = React.useState<any[]>([]);
  const [allSubSpecialities, setAllSubSpecialities] = React.useState<any[]>([]);
  const [fields, setFields] = React.useState(gridSpecs.current.getOrderMatchFilters());

  //Fetches the Lookup details for the filters
  React.useEffect(() => {
    fetchFilterSpecs('', {
      setAllSpecialities,
      setAllSubSpecialities,
      allCitiesandZipsData,
      gridSpecs,
      setFields,
    });
  }, []);
  const matchingDivisions = (props.divisions ?? []).filter(
    divisionType => divisionType.name === candidateDetails?.divisionType,
  );
  const defaultAppliedFilters = getDefaultAppliedFilters({ matchingDivisions, skillset });
  const orderPreferencePreFilters = getOrderPreferencePreFilters({
    matchingDivisions,
    matchingStateOpts,
    orderPreferenceResult,
    matchingShiftOpts,
    prefSkillset,
  });
  const resetFilter = () => {
    if (!orderPrefId) {
      Object.entries(defaultAppliedFilters).map(item => setValue(item[0], item[1]));
      props.onApplyFilter(defaultAppliedFilters);
    } else {
      Object.entries(orderPreferencePreFilters).map(item => setValue(item[0], item[1]));
      props.onApplyFilter(orderPreferencePreFilters);
    }
  };
  const handleChange = () => {
    dispatch(gridStateActions.setFiltersExpanded(!filtersExpanded));
  };

  const updateGridState = useCallback(
    async (selectedStates: string[], selectedCities: string[], gridStateFilters: any) => {
      if (!gridStateFilters || !allCitiesandZipsData.current) return;
      let filteredZips: IStateCityZip[];
      let filteredCities: IStateCityZip[];
      if (!selectedStates.length) filteredCities = allCitiesandZipsData.current;
      else {
        filteredCities = (await getCitiesAndZipsByStates({
          states: selectedStates,
          cities: [],
        })) as IStateCityZip[];
      }

      if (!selectedCities.length) filteredZips = filteredCities;
      else {
        filteredZips = (await getCitiesAndZipsByStates({
          states: selectedStates,
          cities: selectedCities,
        })) as IStateCityZip[];
      }
      gridSpecs.current.filterSpecs.cityOptions = getAllCitiesAndZips(filteredCities).cities;
      gridSpecs.current.filterSpecs.zipOptions = getAllCitiesAndZips(filteredZips).zips;
      gridSpecs.current.gridStateFilters = gridStateFilters;
      const fieldsSchema = gridSpecs.current.getOrderMatchFilters();
      setFields(fieldsSchema);
    },
    [],
  );

  useEffect(() => {
    const defaultSkillsets = [
      ...(candidateDetails?.verifiedSkills || []),
      ...(candidateDetails?.unVerifiedSkills || []),
    ]
      .filter(item => !!item)
      .reduce((resultArray, item) => {
        if (!item?.disciplineId || !item?.disciplineAbbr) {
          return resultArray;
        }
        const newSkill = {
          disciplineId: item?.disciplineId,
          disciplineAbbr: item?.disciplineAbbr,
          specialtyId: item?.specialtyId,
          specialtyAbbr: item?.specialtyAbbr,
          subSpecialtyId: item?.subSpecialtyId,
          subSpecialtyAbbr: item?.subSpecialtyAbbr,
        };
        resultArray?.push(newSkill);
        return resultArray;
      }, []);
    //@ts-ignore
    setSkillset(getSkillSets(defaultSkillsets));
  }, [candidateDetails]);

  useEffect(() => {
    const fetchData = async () => {
      let preferenceValues = null;
      const disciplines = orderPreferenceResult?.newDisciplineSkill;
      const specialties = orderPreferenceResult?.newSpecialtySkill;

      if (disciplines?.length > 0) {
        preferenceValues = await getDisciplineAndSpecialty(disciplines, specialties);
        setPrefSkillset(preferenceValues);
        setValue(OrderMatchFlterName.skillsetFilter, preferenceValues);
      }
    };

    fetchData();
  }, [orderPreferenceResult, candidateId, candidateBrandId]);

  useEffect(() => {
    if (orderPreferenceId && jobPreferencesData) {
      setOrderPreferenceResult(processJobPreferencesData(jobPreferencesData, orderPreferenceId));
      Object.entries(orderPreferencePreFilters).map(item => setValue(item[0], item[1]));
      props.onApplyFilter(orderPreferencePreFilters);
    }
  }, [orderPreferenceId, jobPreferencesData, candidateId, candidateBrandId]);

  const resetToDefaultFilter = () => {
    dispatch(getCandidateOrderMatchActions.setId(null));
    Object.entries(defaultAppliedFilters).map(item => setValue(item[0], item[1]));
    props.onApplyFilter(defaultAppliedFilters, undefined, manualFilterApply);
  };

  React.useEffect(() => {
    if (!userPreference.loaded) return;
    if (skillset && !orderPrefId) {
      if (!savedUserFilterPreferences) {
        resetFilter();
      } else {
        //If there is user Preference saved, apply those preferences -
        const appliedFilters = savedUserFilterPreferences?.value?.filtersApplied;
        const selectedChips = savedUserFilterPreferences?.value?.selectedChipFilters;
        if (appliedFilters) {
          if (!!appliedFilters) {
            Object.keys(appliedFilters).forEach(key => {
              setValue(key, appliedFilters[key]);
            });
            setValue(
              OrderMatchFlterName.skillsetFilter,
              savedUserFilterPreferences?.value?.filtersApplied?.skillsetFilter,
            );
            props.onApplyFilter(appliedFilters, selectedChips);
            dispatch(
              gridStateActions.setFilterAttributes({
                filterObject: Object.entries(appliedFilters),
                selectedChipFilters: selectedChips,
              }),
            );
          }
        }
      }
    } else if (prefSkillset && orderPrefId) resetFilter();
  }, [orderPrefId, skillset, prefSkillset, userPreference.loaded]);

  useEffect(() => {
    if (!gridStateFilters || !allCitiesandZipsData.current) return;
    const selectedStates = !(gridStateFilters?.filters?.states as any[])?.length
      ? []
      : (gridStateFilters?.filters?.states as any[]).reduce(
          (result, item) => (!item?.isCompactOpt ? [...result, item] : result),
          [],
        );

    const selectedCities = (
      !(gridStateFilters?.filters?.city as any[])?.length ? [] : gridStateFilters?.filters?.city
    ) as any[];
    updateGridState(
      selectedStates.map(x => x.name),
      selectedCities.map(x => x.name),
      gridStateFilters,
    );
  }, [gridStateFilters, updateGridState]);

  useEffect(() => {
    findspecialities({
      disciplines: gridStateFilters?.filters?.disciplineIds,
      gridSpecs,
      allSpecialities,
      setFields,
      allSubSpecialities,
    });
  }, [gridStateFilters?.filters?.disciplineIds]);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (gridStateFilters?.filters?.specialtyIds?.length > 0) {
      findSubSpecialities({
        specialities: gridStateFilters?.filters?.specialtyIds,
        gridSpecs,
        allSubSpecialities,
        setFields,
      });
    } else {
      findspecialities({
        disciplines: gridStateFilters?.filters?.disciplineIds,
        gridSpecs,
        allSpecialities,
        setFields,
        allSubSpecialities,
      });
    }
  }, [gridStateFilters?.filters?.specialtyIds]);

  const onApplyEvent = (name: string, value: any) => {
    if (name === 'states' || name === 'city' || name === 'zipCode') {
      dispatch(jobPreferncesActions.setManualChangeInPreference(true));
    }
  };
  return candidateDetailsLoading ? (
    <Skeleton variant="rounded" width={'100%'} height={50} />
  ) : (
    <Grid container spacing={2}>
      <Grid item xs={11}>
        <Collapse timeout={200} in={filtersExpanded} collapsedSize={45} className={classes.collapse}>
          <div>
            <CustomFilter
              fields={fields}
              justifyContent={'flex-start'}
              version2
              resetBtn
              onResetForm={() => resetFilter()}
              analytics={{
                caller: t('Candidate Order Match'),
                onApply: true,
                properties: {
                  category: SearchType.order,
                },
              }}
              onApply={onApplyEvent}
            />
          </div>
        </Collapse>
      </Grid>
      <Grid item xs={1} className={classes.fillterCollapse}>
        <SearchPageIcons
          resetlbutton
          funnelButton
          checked={filtersExpanded}
          onResetForm={() => resetToDefaultFilter()}
          onAdvancedFilterClick={() => handleChange()}
        />
      </Grid>
    </Grid>
  );
};

export default OrderMatchesFilters;
